<div class="bonus-container">
  <div class="bonus-content">
    <div class="bonus-header flex justify-between items-center">
      <div class="bonus-title flex flex-row items-center">
        <img src="/assets/icons/bonus.svg" alt="Bonus" />
        <div class="title">Events</div>
      </div>
      <div>
        <a *ngIf="showAddButton" [routerLink]="['/', 'bonus-event', 'form', 'new']" class="button-add">Add New</a>
      </div>
    </div>
    <div class="flex">
      <mat-table #table class="grow-1" (matSortChange)="sortTable($event)" [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.name }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="pricingType">
          <mat-header-cell *matHeaderCellDef>Pricing Type</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span *ngIf="row.pricingType === 'flat_rate_cents'">Flat Rate Cents</span>
            <span *ngIf="row.pricingType === 'percent'">Percent</span>
            <span *ngIf="row.pricingType === 'per_ton'">Per Ton</span>
            <span *ngIf="row.pricingType === 'per_approved_mile'">Per Approved Mile</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="pricingValue">
          <mat-header-cell *matHeaderCellDef>Pricing Value</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.pricingValue }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="startAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Starts At</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.startAt | standardDate }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="endAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Ends At</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.endAt | standardDate }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="loadCount">
          <mat-header-cell *matHeaderCellDef>Load Count</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.totalOrderCount | dashIfNothing }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="totalBonusAmount">
          <mat-header-cell *matHeaderCellDef>Total Bonus Payment</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.totalBonusAmount | currencyInPennies: 'USD':'$' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="quota">
          <mat-header-cell *matHeaderCellDef>Quota</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.quota | dashIfNothing }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Created At</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.createdAt | standardDate }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="update" *ngIf="showAddButton">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let row">
            <a class="mx-auto flex items-center" [routerLink]="['/', 'bonus-event', 'form', 'edit', row.id]">
              <img src="/assets/icons/pencil.svg" alt="Update" />
            </a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="delete" *ngIf="showAddButton">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div class="mx-auto flex justify-end">
              <img src="/assets/icons/delete-bin.svg" alt="Update" (click)="deleteBonusEvent(row)" />
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          [class.clickable]="showAddButton"
          (click)="onRowClicked(row)"
          [class.nonClickable]="!showAddButton"
        >
        </mat-row>
      </mat-table>
    </div>
  </div>
</div>
